import { Hint, Label, Select } from '@lokalise/louis';

import type { ExportNullAs } from '../../../../types';

type Option = { value: ExportNullAs; label: string };

export interface ExportNullAsInputProps {
    value: ExportNullAs;
    options: readonly Option[];
    onChange: (value: ExportNullAs) => void;
}

const ExportNullAsInput = ({ value, options, onChange }: ExportNullAsInputProps) => (
    <Label
        id="ExportNullAsInput"
        text={
            <>
                Null translations{' '}
                <Hint>
                    Using this option you can choose what to do with the keys that have translations set to NULL.
                </Hint>
            </>
        }
    >
        <Select
            aria-labelledby="ExportNullAsInput"
            value={options.find((item) => value === item.value)}
            options={options}
            onChange={(val) => {
                if (val === null) {
                    return;
                }
                onChange(val.value);
            }}
        />
    </Label>
);

export default ExportNullAsInput;
